<template>
  <el-dialog
    :title="title"
    :visible.sync="show"
    :width="width"
    :custom-class="customClass"
    :destroy-on-close="destroyChild"
    append-to-body
    :before-close="close"
    @open="open"
    @closed="closed"
    :modal="hasModal"
    :show-close="showClose"
    :close-on-click-modal="modalClose"
  >
    <slot slot="title" name="title"></slot>
    <slot></slot>
    <slot slot="footer" name="footer">
      <span slot="footer" class="dialog-footer" v-if="btnShow">
        <el-button v-if="showCancelBtn" size="medium" @click="cancel">{{
          cancelBtn
        }}</el-button>
        <!-- <el-button v-if="!disConfirm" size="medium" type="primary" :disabled="disConfirm" @click="confirm">{{ confirmBtn }}</el-button> -->
        <el-button
          size="medium"
          type="primary"
          :disabled="disConfirm"
          @click="confirm"
        >
          {{ confirmBtn }}
        </el-button>
      </span>
    </slot>
  </el-dialog>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: "提示",
    },
    show: {
      type: Boolean,
      default: false,
    },
    width: {
      type: String,
      default: "368px",
    },
    hasModal: {
      type: Boolean,
      default: true,
    },
    cancelBtn: {
      type: String,
      default: "取消",
    },
    confirmBtn: {
      type: String,
      default: "确认",
    },
    btnShow: {
      type: Boolean,
      default: true,
    },
    // 是否显示关闭按钮
    showClose: {
      type: Boolean,
      default: true,
    },
    // 是否嵌套弹框
    isNest: {
      type: Boolean,
      default: false,
    },
    // 是否显示取消按钮
    showCancelBtn: {
      type: Boolean,
      default: true,
    },
    // 是否禁用按钮
    disConfirm: {
      type: Boolean,
      default: false,
    },
    // 是否点击遮罩层关闭
    modalClose: {
      type: Boolean,
      default: false,
    },
    destroyChild: {
      type: Boolean,
      default: false,
    },
    customClass: {
      type: String,
      default: "",
    },
  },
  methods: {
    // 取消
    cancel() {
      // 判断是否父类弹框嵌套该弹框如果是则有父类控制弹框显示
      if (!this.isNest) {
        this.$emit("update:show", false);
      }
      this.$emit("cancel");
    },
    // 关闭
    close() {
      // 判断是否父类弹框嵌套该弹框如果是则有父类控制弹框显示
      if (!this.isNest) {
        this.$emit("update:show", false);
      }
      this.$emit("close");
    },
    // 打开时的回调
    open() {
      this.$emit("open");
    },
    // 关闭后的回调
    closed() {
      this.$emit("closed");
    },
    // 确认
    confirm(e) {
      this.$emit("confirm", e);
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  .el-dialog {
    margin: 0 !important;
    border-radius: 4px;
    .el-dialog__header {
      padding: 24px;
      .el-dialog__title {
        font-size: 16px;
        color: #202d40;
        font-weight: 500;
        line-height: 16px;
      }
      .el-dialog__headerbtn {
        width: 24px;
        height: 24px;
        top: 19px;
        right: 24px;
        font-size: 20px;
        .el-dialog__close {
          color: #666;
          font-size: 20px;
        }
      }
    }
    .el-dialog__body {
      padding-left: 24px;
      padding-right: 24px;
      padding-top: 0px;
      padding-bottom: 32px;
      // 下拉选择框样式
      .el-input__suffix {
        padding-right: 8px;
        i {
          color: #666;
          font-weight: 900;
        }
      }
    }
    .el-dialog__footer {
      padding-bottom: 24px !important;
      padding-left: 24px !important;
      padding-right: 24px !important;
      padding-top: 0 !important;
    }
  }
}
</style>
